const MenuEmp = [{
    header: 'Apps'
},
{
    title: 'DashboardEmployee',
    group: 'apps',
    icon: 'dashboard',
    name: 'DashboardEmployee',
},
{
    title: 'CheckSalary',
    group: 'apps',
    icon: 'attach_money',
    name: 'CheckSalary',
},
{
    title: "WorkPlanEmp",
    group: 'apps',
    icon: 'event',
    name: 'WorkPlanEmp',
        
    
},
 {
    divider: true
}
];

export default MenuEmp;